import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMainPlans } from '../../actions';
import { Link, withRouter } from 'react-router-dom'

class Systematize extends Component {
  renderTeamName(){
    if(this.props.team){
      if(this.props.team.company && this.props.team.company !== ""){
        return this.props.team.company;
      }else{
        return this.props.team.firstname+" "+this.props.team.lastname;
      }
    }
    return "";
  }
  render() {
    if(this.props.copy_tab == "systematize"){
      return (
          <div id="systematize" className="systematize-tab tab-container">


              <div style={{margin: 20, textAlign: "center"}}>
                <h2>What do you need to get started? </h2>
              </div>

              <div className="card flex-item">
                <div className="card-body">
                    <div className="feature">
                      <i className="fa fa-user"></i>
                      <div className="feature-text">
                        <h4>Be at least 18 years old</h4>
                    </div>
                  </div>
                </div>
              <div className="card-body">
                <div className="feature">
                  <i className="fa fa-id-card"></i>
                    <div className="feature-text">
                      <h4>Valid driver's license</h4>
                    </div>
                  </div>
                </div>


              <div className="card-body">
                <div className="feature">
                  <i className="material-icons">directions_car</i>
                    <div className="feature-text">
                      <h4>Vehicle insurance</h4>
                    </div>
                  </div>
              </div>

              <div className="card-body">
                <div className="feature">
                  <i className="material-icons">check_circle</i>
                    <div className="feature-text">
                      <h4>At least 1 year of driving experience</h4>
                    </div>
                  </div>
              </div>

              <div className="card-body">
                <div className="feature">
                  <i className="material-icons">smartphone</i>
                    <div className="feature-text">
                      <h4>Have an Android or iPhone smartphone and enjoy using technology</h4>
                    </div>
                  </div>
              </div>





            </div>
              <div style={{margin: 20, marginBottom:60, textAlign: "center"}}>
                <h2>Start Earning Today</h2>
                <p><a href={'tel:'+this.props.team.phone}>{this.props.team.phone}</a></p>
                <p>This offer is provided by <b>{this.renderTeamName()}</b>, who will provide you with access to DealMachine, the mobile app you’ll use to take pictures. <b>{this.renderTeamName()}</b> will provide you with a partner contract, and will be the party responsible for paying you.</p>
              </div>
          </div>

      );
    }else{
      return <div />;
    }
  }
};

const mapStateToProps = ({ auth }) => {
  const { copy_tab, team, plans, plans_loading, plans_error, signup_type, signup_team_name, signup_team_company } = auth;
  return { copy_tab, team, plans, plans_loading, plans_error, signup_type, signup_team_name, signup_team_company }
}

export default withRouter(connect(mapStateToProps, {})(Systematize));



// WEBPACK FOOTER //
// ./src/components/GetStarted/Systematize.js